import React, { createRef, useState, useEffect } from 'react';

function Styling(props) {

    return (
        <div>
            Hacky page so I can see the styles
            <h1>Header 1</h1>
            <h2>Header 2</h2>
            <h2>Header 3</h2>
            <h4>Header 4</h4>
            <h5>Header 5</h5>
            <h6>Header 6</h6>
        </div>
    );
}

export default Styling;